<div class="widget container p-3 ruleChainContainer">
  <p-table
    [scrollable]="true"
    [columns]="ruleChainColumns"
    class="p-3 fullTable tableHeaderAlignTop"
    [value]="ruleChains()"
  >
    <ng-template #caption>
      <div class="flex justify-content-between w-full">
        <span>
          {{ "butler_programming.rule_chains.table.title" | translate }}
        </span>
        <app-svg-icon
          iconName="plus"
          iconColor="primary"
          class="pointer"
          (click)="openCreateRuleChain()"
        ></app-svg-icon>
      </div>
    </ng-template>
    <ng-template #header let-columns>
      <tr>
        @for (col of columns; track col) {
          <th>{{ col.header | translate }}</th>
        }

        <th></th>
      </tr>
    </ng-template>
    <ng-template #body let-rowData let-columns="columns">
      <tr>
        @for (col of columns; track col) {
          <td>{{ rowData[col.field] | yesNo }}</td>
        }
        <td class="flex gap-3 justify-content-end">
          <app-svg-icon
            style="align-content: center"
            iconName="eye"
            iconColor="primary"
            class="pointer"
            (click)="openRuleChain(rowData.id)"
          ></app-svg-icon>
          <app-svg-icon
            style="align-content: center"
            iconName="edit"
            iconColor="primary"
            class="pointer"
            (click)="openEditRuleChain(rowData)"
          ></app-svg-icon>
          <app-svg-icon
            style="align-content: center"
            iconName="trash"
            iconColor="primary"
            class="pointer"
            (click)="deleteRuleChain($event, rowData.id)"
          ></app-svg-icon>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
